import { useState } from 'react'

import { WidgetContextProvider } from '../../Widget'
import { ComponentProps } from '../Component'
import { boolean, controls } from '../Controls'

export function WidgetProviderProps({ children }) {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('isEditMode'))
      .add(boolean('isExpanded', true))
  )

  function handleToggleExpanded() {
    setProps(currProps =>
      currProps.setValue('isExpanded', !currProps.controls.isExpanded.value)
    )
  }

  function handleEnableEditMode() {
    setProps(currProps => currProps.setValue('isEditMode', true))
  }

  function handleDisableEditMode() {
    setProps(currProps => currProps.setValue('isEditMode', false))
  }

  return (
    <WidgetContextProvider
      {...props.getValues()}
      onDisableEditMode={handleDisableEditMode}
      onEnableEditMode={handleEnableEditMode}
      onToggleExpanded={handleToggleExpanded}
    >
      {children}
      <ComponentProps name='WidgetProvider' value={props} onChange={setProps} />
    </WidgetContextProvider>
  )
}
